import { useContext } from 'react';
import { EventContext } from '../Context/EventContext';
import { useNotes } from './useNotes';

// eslint-disable-next-line import/prefer-default-export
export const useEventNotes = () => {
  const { event } = useContext<any>(EventContext) ?? {};
  const { id: eventId, customerId } = event ?? {};

  const {
    loading: loadingEventNotes,
    notes: eventNotes,
    addingNote,
    add,
    remove: removeEventNote,
    update: updateEventNote,
  } = useNotes('events', eventId);
  const {
    loading: loadingCustomerNotes,
    notes: customerNotes,
    update: updateContactNote,
    remove: removeContactNote,
  } = useNotes('contacts', customerId);

  return {
    loading: loadingEventNotes || loadingCustomerNotes,
    eventNotes,
    customerNotes,
    length: eventNotes.length + customerNotes.length,
    add,
    addingNote,
    removeEventNote,
    removeContactNote,
    updateContactNote,
    updateEventNote,
  };
};
